var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8243 62.2181L31.4469 63.6021L33.6278 63.7136L38.2868 62.9512L43.0101 61.8113L49.6929 58.2849L56.553 52.199L57.8807 50.4822L60.2446 46.4812L62.4614 42.5846L63.4048 37.0474L64.2311 29.1595L61.699 21.9959L57.6791 14.4501L52.0985 9.22898L47.8712 6.69801L37.2486 3.72804L25.6025 5.24581L16.4201 9.77187L9.93734 15.9219L5.65685 22.0577L4.16748 27.7611L3.23393 36.2783L6.44191 47.8298L10.7991 54.9149L18.4562 60.1003L24.8243 62.2181Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBg);
export default __webpack_public_path__ + "static/media/circle_bg.907dad93.svg";
export { ForwardRef as ReactComponent };